import React from 'react';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle, CheckCircle, Clock, XCircle } from 'lucide-react';

interface ComplianceBadgeProps {
  status: 'compliant' | 'non_compliant' | 'expired' | 'expiring_soon';
  missingCount?: number;
  expiredCount?: number;
  expiringSoonCount?: number;
  className?: string;
}

export const ComplianceBadge: React.FC<ComplianceBadgeProps> = ({
  status,
  missingCount = 0,
  expiredCount = 0,
  expiringSoonCount = 0,
  className
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'compliant':
        return {
          variant: 'default' as const,
          icon: CheckCircle,
          text: 'Compliant',
          className: 'bg-green-100 text-green-800 border-green-200'
        };
      case 'non_compliant':
        return {
          variant: 'destructive' as const,
          icon: XCircle,
          text: `${missingCount} Missing`,
          className: 'bg-red-100 text-red-800 border-red-200'
        };
      case 'expired':
        return {
          variant: 'destructive' as const,
          icon: AlertTriangle,
          text: `${expiredCount} Expired`,
          className: 'bg-red-100 text-red-800 border-red-200'
        };
      case 'expiring_soon':
        return {
          variant: 'secondary' as const,
          icon: Clock,
          text: `${expiringSoonCount} Expiring`,
          className: 'bg-orange-100 text-orange-800 border-orange-200'
        };
      default:
        return {
          variant: 'outline' as const,
          icon: AlertTriangle,
          text: 'Unknown',
          className: ''
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <Badge 
      variant={config.variant} 
      className={`${config.className} ${className}`}
    >
      <Icon className="h-3 w-3 mr-1" />
      {config.text}
    </Badge>
  );
};